const header_menu_el = document.querySelector('.header__menu');
const header_el = document.querySelector('.header');

document.querySelector('.header-burger')?.addEventListener('click', function () {
    header_el.classList.toggle('active');
    this.classList.toggle('active');

    if (header_el.classList.contains('active')) {
        header_menu_el.style.paddingTop = `${header_el.offsetHeight}px`;
    }
    else {
        header_menu_el.style.paddingTop = null;
    }
});